import React from 'react';
import { House } from 'react-bootstrap-icons';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
export default function ItemHeader(props) {
	const { IsadgData } = props;
	const agency =
		IsadgData?.isadg?.agency === 1 ? 'GT-CIRMA-AH' : 'GT-CIRMA-FG';
	function renderAncestorChild(ancestor) {
		return (
			<>
				{ancestor.parent && renderAncestorChild(ancestor.parent)}
				<li>
					<Link
						to={
							process.env.PUBLIC_URL +
							'/collection/' +
							ancestor.root +
							'?nav=' +
							ancestor.code
						}
					>
						{ancestor.display_name}
					</Link>
				</li>
			</>
		);
	}

	return (
		<div className='ith'>
			<Container>
				<div className='itcd isadg-code'>{IsadgData.isadg?.code}</div>
				<h2 className='ittit'>{IsadgData.isadg?.display_name}</h2>
				<div className='itbrd'>
					<ul>
						<li>
							<Link
								to={
									process.env.PUBLIC_URL + '/agency/' + agency
								}
							>
								<House />
							</Link>
						</li>
						<li>
							<Link
								to={
									process.env.PUBLIC_URL + '/agency/' + agency
								}
							>
								{IsadgData.isadg?.agency === 1
									? 'Archivo Histórico'
									: 'Fototeca Guatemala'}
							</Link>
						</li>
						{IsadgData?.ancestors &&
							renderAncestorChild(IsadgData.ancestors)}

						<li className='act'>{IsadgData.isadg?.display_name}</li>
					</ul>
				</div>
			</Container>
		</div>
	);
}
